import React from 'react';
import {Button} from 'antd-mobile';
import {ProgressiveCircularLoading} from '@fe-progressive/package-progressive/progressive-loading';
import {CheckInStatus} from './types';

const buttonLoading = (
  <ProgressiveCircularLoading
    size={16}
    color="#fff"
    trackColor="rgba(255, 255, 255, 0.35)"
  />
);

export interface CheckInButtonProps {
  status: CheckInStatus;
  isCheckingIn?: boolean;
  isReceivingReward?: boolean;
  onCheckIn?: () => void;
  onClaimReward?: () => void;
  disabled?: boolean;
}

const CheckIcon = () => {
  return (
    <svg className="size-3" viewBox="0 0 13 13" fill="none">
      <path
        d="M2 6L4.88889 9.11111L10.5 3.5"
        stroke="#00B512"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};

/**
 * 签到页面按钮组件
 * 根据状态自动显示合适的按钮或标识
 */
const CheckInButton: React.FC<CheckInButtonProps> = ({
  status,
  isCheckingIn = false,
  isReceivingReward = false,
  onCheckIn,
  onClaimReward,
  disabled = false,
}) => {
  switch (status) {
    case CheckInStatus.COMPLETED:
      // 已签到且已领取奖励 - 显示完成标识
      return (
        <div className="flex justify-center">
          <div className="bg-[#C6C6C6] p-2 rounded-full font-bold text-[#5F6975] text-xs flex items-center justify-center origin-top-left">
            <CheckIcon />
          </div>
        </div>
      );

    case CheckInStatus.EXPIRED:
      // 过期状态 - 显示过期标识
      return (
        <div className="flex justify-center">
          <div className="bg-[#C6C6C6] p-2 rounded-full font-bold text-[#5F6975] text-xs flex items-center justify-center origin-top-left">
            Expired
          </div>
        </div>
      );

    case CheckInStatus.CHECKED_IN:
    case CheckInStatus.TASK_COMPLETED:
      // 已签到且任务完成但未领取奖励 - 显示领取按钮
      return (
        <Button
          className="text-white h-8 w-full overflow-hidden text-sm font-bold flex justify-center items-center border border-[#e26900] bg-gradient-to-b from-[#FFA800] to-[#FF6B00] shadow-[inset_0_2px_2px_0_rgba(255,255,255,0.5)] rounded-full p-2"
          onClick={onClaimReward}
          disabled={disabled || isReceivingReward}>
          {isReceivingReward ? buttonLoading : 'Claim'}
        </Button>
      );
    // 锁定状态 - 显示占位空间
    // 可签到 - 显示签到按钮
    case CheckInStatus.AVAILABLE:
    case CheckInStatus.LOCKED:
      return (
        <Button
          className="text-white h-8 w-full overflow-hidden text-sm font-bold flex justify-center items-center border border-[#e26900] bg-gradient-to-b from-[#FFA800] to-[#FF6B00] shadow-[inset_0_2px_2px_0_rgba(255,255,255,0.5)] rounded-full p-2 tracking-[-1px]"
          onClick={onCheckIn}
          disabled={disabled || isCheckingIn}>
          {isCheckingIn ? buttonLoading : 'Check In'}
        </Button>
      );
    default:
      return <div className="h-8" />;
  }
};

export default CheckInButton;
